export const bookData = {
  title: "THE FOUR GATES WITHIN",
  subtitle: "How to live according to your stars. Step by step",
  price: 14.9,
  currency: "€",
  coverImage: "https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/5b677c5ea951491f9b6dd69d10490950.png",
  logoImage: "https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/d4ec553dfab1e13661941b103948c86a.png",
  pages: 90,
  chapters: 4,
  exercises: 15,
  rating: 4.9,
  readers: 2847,
  recommendationRate: 98
};

export const features = [
  {
    icon: "ri-rocket-line",
    title: "Quick Start Page",
    description: "So you immediately know how to use the book and start your journey without any questions or doubts."
  },
  {
    icon: "ri-scales-line",
    title: "Element Balance Diagnostics",
    description: "Find out which energies you have too much of and which you lack – and get concrete solutions to restore balance."
  },
  {
    icon: "ri-compass-3-line",
    title: "4 Elements Journey",
    description: "Deep dive into each element – Fire, Air, Water, and Earth – with practical insights and exercises."
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Practices and Mini Rituals",
    description: "Simple 5–10 minute exercises you can do anytime, anywhere – without any complicated tools."
  },
  {
    icon: "ri-map-2-line",
    title: "Your Soul Map",
    description: "Step-by-step guide on how to create your unique soul map and interpret it."
  },
  {
    icon: "ri-gift-line",
    title: "Completion Ritual. Soul Promises",
    description: "Powerful closing ceremony that helps solidify changes and make important promises to yourself for the future."
  }
];

export const journeySteps = [
  {
    number: 1,
    title: "Quick Start Page",
    description: "So you immediately know how to use the book and start your journey without any questions or doubts."
  },
  {
    number: 2,
    title: "Element Balance Diagnostics",
    description: "Find out which energies you have too much of and which you lack – and get concrete solutions to restore balance."
  },
  {
    number: 3,
    title: "4 Elements Journey",
    description: "Deep dive into each element – Fire, Air, Water, and Earth – with practical insights and exercises."
  },
  {
    number: 4,
    title: "Practices and Mini Rituals",
    description: "Simple 5–10 minute exercises you can do anytime, anywhere – without any complicated tools."
  },
  {
    number: 5,
    title: "Your Soul Map",
    description: "Step-by-step guide on how to create your unique soul map and interpret it."
  },
  {
    number: 6,
    title: "Completion Ritual. Soul Promises",
    description: "Powerful closing ceremony that helps solidify changes and make important promises to yourself for the future."
  }
];

export const testimonials = [
  {
    name: "Sarah",
    city: "New York",
    rating: 5,
    text: "Really helpful! The exercises are easy to follow and actually work. Would recommend"
  },
  {
    name: "Michael",
    city: "Toronto",
    rating: 5,
    text: "I was skeptical at first but this book explains everything in a practical way. Now I understand myself better"
  },
  {
    name: "Emma",
    city: "Los Angeles",
    rating: 5,
    text: "Great book! Simple practices that fit into my daily routine. Already shared it with friends"
  },
  {
    name: "James",
    city: "Vancouver",
    rating: 5,
    text: "Worth it. Finally understand why I connect better with some people than others"
  },
  {
    name: "Sophie",
    city: "Chicago",
    rating: 4,
    text: "Good for beginners. Everything is clearly explained, no special knowledge needed"
  },
  {
    name: "David",
    city: "Montreal",
    rating: 5,
    text: "I like that it's not just theory but actual exercises you can do. Changed my perspective"
  }
];

export const stats = [
  { value: "MOBILE", label: "Optimized for phone reading" },
  { value: "BEGINNERS", label: "Clear from page one" },
  { value: "INSTANT", label: "PDF right after payment" },
  { value: "PRACTICES", label: "5–10 min per day" }
];

export const trustBadges = [
  { icon: "ri-lock-line", text: "Secure payment" },
  { icon: "ri-flashlight-line", text: "Instant delivery" }
];
